import { Injectable } from '@angular/core';
import { HttpClient, HttpClientJsonpModule } from '@angular/common/http';
import 'rxjs/Rx';

@Injectable({
	providedIn: 'root',
})
export class OldDataService {
	public value = 'Probando';
	constructor(private http: HttpClient) {}

	get(url: string): Promise<any> {
		return new Promise((resolve) => {
			return this.http.get(url).subscribe((data) => {
				resolve(data);
			});
		});
	}

	post(url: string, values: any): Promise<any> {
		return new Promise((resolve) => {
			return this.http
				.post<any>(url, values, {
					headers: {
						'Content-Type':
							'application/x-www-form-urlencoded; charset=UTF-8',
					},
				})
				.subscribe(
					(data) => {
						resolve(data);
					},
					(error) => {},
				);
		});
	}

	postObservable(url: string, values: any) {
		return this.http.post<any>(url, values, {
			headers: {
				'Content-Type':
					'application/x-www-form-urlencoded; charset=UTF-8',
			},
		});
	}

	getObservable(url: string) {
		return this.http.get(url);
	}
}
